/* Belessa Beauty — entradas al hacer scroll, filtro por necesidad y «+» para agregar al carrito. Sin librerías. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Entradas: cada parte de la sección sube y aparece, escalonada 70 ms. El contenido es visible si no hay JS. */
  function initIn(root) {
    var els = root.querySelectorAll('[data-bb-in]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var sec = en.target.closest('.shopify-section') || document.body;
        var group = Array.prototype.slice.call(sec.querySelectorAll('[data-bb-in]:not(.is-in)'));
        group.forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.95) { el.style.setProperty('--bb-d', Math.min(i, 6) * 70 + 'ms'); el.classList.add('is-in'); io.unobserve(el); }
        });
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Foto de la rutina: desplazamiento lento ligado al scroll (solo transform) */
  function initDrift() {
    if (reduce) return;
    var imgs = document.querySelectorAll('[data-bb-drift]');
    if (!imgs.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      imgs.forEach(function (img) {
        var r = img.parentNode.getBoundingClientRect();
        var p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        if (p < 0 || p > 1) return;
        img.style.transform = 'scale(1.08) translateY(' + ((p - 0.5) * -6).toFixed(2) + '%)';
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Filtro por necesidad de la piel */
  function initShelf(shelf) {
    var pills = shelf.querySelectorAll('[data-bb-filter]');
    var cards = shelf.querySelectorAll('.bb-card');
    var empty = shelf.querySelector('[data-bb-empty]');
    var status = shelf.querySelector('[data-bb-status]');
    var limit = Number(shelf.getAttribute('data-bb-limit')) || 999;
    cards.forEach(function (c, i) { if (i >= limit) c.hidden = true; });
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.getAttribute('aria-pressed') === 'true') return;
        pills.forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
        var wanted = pill.getAttribute('data-bb-filter').split(',').filter(Boolean);
        var shown = 0;
        cards.forEach(function (card, idx) {
          var tags = card.getAttribute('data-tags') || '';
          var ok = wanted.length ? wanted.some(function (t) { return tags.indexOf(' ' + t + ' ') > -1; }) : idx < limit;
          if (ok) shown++;
          if (reduce) { card.hidden = !ok; return; }
          if (!ok && !card.hidden) {
            card.classList.add('is-leaving');
            setTimeout(function () { card.hidden = true; card.classList.remove('is-leaving'); }, 160);
          } else if (ok && card.hidden) {
            setTimeout(function () {
              card.hidden = false; card.classList.add('is-leaving');
              requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.remove('is-leaving'); }); });
            }, 160);
          }
        });
        if (empty) empty.hidden = shown > 0;
        if (status) status.textContent = shown + (shown === 1 ? ' producto' : ' productos') + ' para ' + pill.textContent.trim();
      });
    });
  }

  /* «+» agrega al carrito y abre el cajón de Dawn. Delegado: funciona también en catálogo y recomendaciones que cargan después. */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-bb-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-icon-bubble'];
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-bb-add')), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status && res.description) { var cont = btn.closest('.bb-card, .bb-cd__rec'); var l = cont && cont.querySelector('.bb-card__title a, .bb-cd__rec-name'); if (l) window.location.href = l.href; return; }
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
        if (drawer && drawer.renderContents) {
          res.id = res.items && res.items[0] ? res.items[0].id : undefined;
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = '/cart'; });
  });

  /* Portada: cambia de foto cada N segundos sin detenerse (ni con el mouse encima).
     Solo se pausa cuando la persona elige una foto con los puntos, las flechas o deslizando; retoma sola 15 s después. */
  function initShow(show) {
    if (show.dataset.bbReady) return;
    show.dataset.bbReady = '1';
    var slides = show.querySelectorAll('.bb-slide');
    var dots = show.querySelectorAll('[data-bb-dot]');
    if (slides.length < 2) return;
    var ms = (parseInt(show.dataset.bbSegundos, 10) || 5) * 1000;
    var cur = 0, timer = null, paused = false, retomar = null;
    function elegir(n) { go(n); paused = true; stop(); clearTimeout(retomar); retomar = setTimeout(function () { paused = false; start(); }, 15000); }
    // Las fotos se descargan por turnos: la que se muestra y la siguiente
    function preparar(i) { cargarFotos(slides[(i + slides.length) % slides.length]); }
    if (document.readyState === 'complete') preparar(1);
    else window.addEventListener('load', function () { preparar(1); });

    function go(n) {
      cur = (n + slides.length) % slides.length;
      preparar(cur); preparar(cur + 1);
      show.classList.add('is-moved');
      slides.forEach(function (s, i) {
        var on = i === cur;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a').forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      });
      dots.forEach(function (d, i) { if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    show.style.setProperty('--bb-show-ms', ms + 'ms');
    function stop() { clearInterval(timer); timer = null; show.classList.remove('is-playing'); }
    function start() { stop(); if (!paused && !document.hidden) { timer = setInterval(function () { go(cur + 1); restart(); }, ms); show.classList.add('is-playing'); restart(); } }
    function restart() { var d = dots[cur]; if (!d) return; var b = d.querySelector('b'); if (b) { b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; } }

    show.querySelector('[data-bb-next]').addEventListener('click', function () { elegir(cur + 1); });
    show.querySelector('[data-bb-prev]').addEventListener('click', function () { elegir(cur - 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { elegir(parseInt(d.dataset.bbDot, 10)); }); });
    document.addEventListener('visibilitychange', start);

    var x0 = null;
    show.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) elegir(cur + (dx < 0 ? 1 : -1));
    });

    show.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target);
      if (i > -1) { paused = true; stop(); go(i); }
    });
    show.addEventListener('shopify:block:deselect', function () { paused = false; start(); });
    start();
  }

  /* Portada: mide el encabezado para que la foto suba debajo de él, y lo pone blanco al bajar */
  function initHead() {
    var head = document.querySelector('.section-header');
    if (!head || !document.body.classList.contains('bb-tpl-index')) return;
    function measure() { document.documentElement.style.setProperty('--bb-head-h', head.offsetHeight + 'px'); }
    function solid() { document.body.classList.toggle('bb-solid', window.scrollY > 8); }
    measure(); solid();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', solid, { passive: true });
  }

  /* Fotos en espera (data-src / data-srcset): se descargan solo cuando hacen falta */
  function cargarFotos(root) {
    if (!root) return;
    root.querySelectorAll('[data-srcset], [data-src]').forEach(function (el) {
      if (el.dataset.srcset) { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); }
      if (el.dataset.src) { el.src = el.dataset.src; el.removeAttribute('data-src'); }
    });
  }
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var gal = e.target.closest && e.target.closest('[data-bb-gal]');
      if (gal) cargarFotos(gal);
    }, { passive: true, capture: true });
  });

  /* Tarjetas de producto: flechas para pasar las fotos (y deslizar con el dedo) */
  function galPaso(gal, paso) {
    cargarFotos(gal);
    var imgs = gal.querySelectorAll('.bb-card__img');
    if (imgs.length < 2) return;
    var cur = 0;
    imgs.forEach(function (im, i) { if (im.classList.contains('is-on')) cur = i; });
    var n = (cur + paso + imgs.length) % imgs.length;
    imgs[cur].classList.remove('is-on');
    imgs[n].classList.add('is-on');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bb-gal-prev], [data-bb-gal-next]');
    if (!b) return;
    e.preventDefault();
    galPaso(b.closest('[data-bb-gal]'), b.hasAttribute('data-bb-gal-next') ? 1 : -1);
  });
  var galX = null;
  document.addEventListener('touchstart', function (e) {
    galX = e.target.closest('[data-bb-gal]') ? e.touches[0].clientX : null;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (galX === null) return;
    var gal = e.target.closest('[data-bb-gal]');
    var dx = e.changedTouches[0].clientX - galX; galX = null;
    if (gal && Math.abs(dx) > 40) galPaso(gal, dx < 0 ? 1 : -1);
  });

  function initMenuHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.header__inline-menu details[data-bb-href]').forEach(function (d) {
      var li = d.closest('li') || d;
      li.addEventListener('mouseenter', function () { d.setAttribute('open', ''); });
      li.addEventListener('mouseleave', function () { d.removeAttribute('open'); });
      // «Tienda» no lleva a ninguna página: solo despliega la lista (con el mouse ya está abierta, el clic no la cierra)
      d.querySelector('summary').addEventListener('click', function (e) { if (e.detail === 0) return; e.preventDefault(); d.setAttribute('open', ''); });
    });
  }

  function init(root) {
    initIn(root);
    root.querySelectorAll('[data-bb-shelf]').forEach(initShelf);
    root.querySelectorAll('[data-bb-show]').forEach(initShow);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); initDrift(); initHead(); initMenuHover(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Reseñas Judge.me: textos en español (la app usa el idioma principal de la tienda) */
(function () {
  var T = {
    'Customer Reviews': 'Reseñas de clientes',
    'Be the first to write a review': 'Sé la primera persona en dejar una reseña',
    'Write a review': 'Escribir una reseña',
    'Cancel review': 'Cancelar',
    'No reviews': 'Sin reseñas',
    'Ask a question': 'Hacer una pregunta',
    'Rating': 'Calificación',
    'Review Title': 'Título de la reseña',
    'Review title': 'Título de la reseña',
    'Review': 'Reseña',
    'Review content': 'Tu reseña',
    'Name': 'Nombre',
    'Email': 'Correo',
    'Picture/Video (optional)': 'Foto o video (opcional)',
    'Picture (optional)': 'Foto (opcional)',
    'Submit Review': 'Enviar reseña',
    'Submit review': 'Enviar reseña',
    'Thank you for submitting a review!': '¡Gracias por tu reseña!',
    'Your review has been submitted and will be published once approved.': 'Recibimos tu reseña. La publicaremos después de revisarla.',
    'Most Recent': 'Más recientes',
    'Highest Rating': 'Mejor calificación',
    'Lowest Rating': 'Peor calificación',
    'Only Pictures': 'Solo con fotos',
    'Pictures First': 'Primero con fotos',
    'Videos First': 'Primero con videos',
    'Most Helpful': 'Más útiles',
    'Verified': 'Verificada',
    'Verified Buyer': 'Compra verificada',
    'Was this review helpful?': '¿Te sirvió esta reseña?',
    'Load More Reviews': 'Ver más reseñas',
    'Reviews': 'Reseñas',
    'Questions': 'Preguntas',
    'Give your review a title': 'Ponle un título a tu reseña',
    'Write your comments here': 'Cuéntanos tu experiencia',
    'Enter your name (public)': 'Tu nombre (público)',
    'Enter your email (private)': 'Tu correo (privado)',
    'Enter your name': 'Tu nombre',
    'Enter your email': 'Tu correo'
  };
  function based(t) {
    var m = t.match(/^Based on (\d+) reviews?$/);
    return m ? 'Basado en ' + m[1] + (m[1] === '1' ? ' reseña' : ' reseñas') : null;
  }
  function count(t) {
    var m = t.match(/^(\d+) reviews?$/);
    return m ? m[1] + (m[1] === '1' ? ' reseña' : ' reseñas') : null;
  }
  function run(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t = n.textContent.trim();
      if (!t) continue;
      var r = T[t] || based(t) || count(t);
      if (r) n.textContent = n.textContent.replace(t, r);
    }
    root.querySelectorAll && root.querySelectorAll('[placeholder]').forEach(function (e) { if (T[e.placeholder]) e.placeholder = T[e.placeholder]; });
    root.querySelectorAll && root.querySelectorAll('input[type=submit], input[type=button]').forEach(function (e) { if (T[e.value]) e.value = T[e.value]; });
  }
  function scan() { document.querySelectorAll('.jdgm-widget, .jdgm-prev-badge, .jdgm-form-wrapper, .jdgm-preview-badge').forEach(run); }
  document.addEventListener('DOMContentLoaded', function () {
    scan();
    var pend = false;
    new MutationObserver(function () { if (pend) return; pend = true; requestAnimationFrame(function () { pend = false; scan(); }); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();

/* "Ordenar por" y selector de transportadora (Rastrear pedido): lista desplegable propia (más fluida que la del navegador). Usa el select original por debajo. */
(function () {
  var NOMBRES = { 'manual': 'Destacados' };
  function cerrarTodos(excepto) {
    document.querySelectorAll('.bb-sort.is-open').forEach(function (s) {
      if (s === excepto) return;
      s.classList.remove('is-open');
      var b = s.querySelector('.bb-sort__btn') || (s.parentElement && s.parentElement.querySelector('select'));
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function mejorar(sel) {
    if (sel.dataset.bbSort) return;
    sel.dataset.bbSort = '1';
    var campo = sel.classList.contains('ag-rt__select'); // campo de formulario: ocupa todo el ancho y sin «Ordenar:»
    var caja = document.createElement('div'); caja.className = 'bb-sort' + (campo ? ' bb-sort--campo' : '');
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'bb-sort__btn';
    if (campo && sel.id) { var lbl = document.querySelector('label[for="' + sel.id + '"]'); btn.id = sel.id + '-btn'; if (lbl) lbl.setAttribute('for', btn.id); }
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var lista = document.createElement('ul'); lista.className = 'bb-sort__list'; lista.setAttribute('role', 'listbox');
    var txt = function (o) { return NOMBRES[o.value] || o.textContent.trim(); };
    function pintar() {
      var actual = sel.options[sel.selectedIndex];
      btn.innerHTML = (campo ? '' : '<span class="bb-sort__lbl">Ordenar:</span> ') + '<span class="bb-sort__val">' + txt(actual) + '</span><svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 5.5l4 4 4-4"/></svg>';
      lista.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (o) {
        var li = document.createElement('li'); li.setAttribute('role', 'option'); li.tabIndex = -1;
        li.dataset.value = o.value; li.textContent = txt(o);
        if (o.selected) { li.setAttribute('aria-selected', 'true'); }
        lista.appendChild(li);
      });
    }
    pintar();
    caja.appendChild(btn); caja.appendChild(lista);
    sel.parentNode.insertBefore(caja, sel);
    sel.classList.add('bb-sort__native');
    var wrap = sel.closest('.select'); if (wrap) wrap.classList.add('bb-sort-host');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var abrir = !caja.classList.contains('is-open'); cerrarTodos(caja);
      caja.classList.toggle('is-open', abrir); btn.setAttribute('aria-expanded', String(abrir));
      if (abrir) { var s = lista.querySelector('[aria-selected="true"]') || lista.firstChild; s && s.focus(); }
    });
    lista.addEventListener('click', function (e) {
      var li = e.target.closest('li'); if (!li) return;
      sel.value = li.dataset.value; pintar();
      caja.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.focus();
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sel.dispatchEvent(new Event('input', { bubbles: true }));
    });
    lista.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(lista.children), i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.activeElement.click(); }
      else if (e.key === 'Escape') { caja.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });
  }
  // Orden de reseñas de Judge.me (botón con ícono): se deja su botón y se cambia solo la lista que se despliega
  function flotante(sel) {
    if (sel.dataset.bbSort) return;
    sel.dataset.bbSort = '1';
    var host = sel.parentElement;
    host.style.position = 'relative';
    var caja = document.createElement('div'); caja.className = 'bb-sort bb-sort--flotante';
    var lista = document.createElement('ul'); lista.className = 'bb-sort__list'; lista.setAttribute('role', 'listbox');
    caja.appendChild(lista); host.appendChild(caja);
    var txt = function (o) { var t = o.textContent.trim().toLowerCase(); return t.charAt(0).toUpperCase() + t.slice(1); };
    function pintar() {
      lista.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (o) {
        var li = document.createElement('li'); li.setAttribute('role', 'option'); li.tabIndex = -1;
        li.dataset.value = o.value; li.textContent = txt(o);
        if (o.value === sel.value) li.setAttribute('aria-selected', 'true');
        lista.appendChild(li);
      });
    }
    function abrir(si) {
      if (si) { cerrarTodos(caja); pintar(); }
      caja.classList.toggle('is-open', si); sel.setAttribute('aria-expanded', String(si));
      if (si) { var s = lista.querySelector('[aria-selected="true"]') || lista.firstChild; s && s.focus(); }
    }
    sel.addEventListener('mousedown', function (e) { e.preventDefault(); abrir(!caja.classList.contains('is-open')); });
    sel.addEventListener('keydown', function (e) {
      if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].indexOf(e.key) > -1) { e.preventDefault(); abrir(true); }
    });
    lista.addEventListener('click', function (e) {
      var li = e.target.closest('li'); if (!li) return;
      sel.value = li.dataset.value;
      abrir(false); sel.focus();
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sel.dispatchEvent(new Event('input', { bubbles: true }));
    });
    lista.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(lista.children), i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.activeElement.click(); }
      else if (e.key === 'Escape') { abrir(false); sel.focus(); }
    });
  }
  function escanear() {
    document.querySelectorAll('select#SortBy, select.facet-filters__sort, select.ag-rt__select').forEach(mejorar);
    document.querySelectorAll('select.jm-sort-filter__select').forEach(flotante);
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.bb-sort, select.jm-sort-filter__select')) cerrarTodos(null); });
  document.addEventListener('DOMContentLoaded', function () {
    escanear();
    new MutationObserver(function () { escanear(); }).observe(document.body, { childList: true, subtree: true });
  });
})();

/* Favoritos: se guardan en este navegador (sin cuenta). Corazón en cada tarjeta, contador en el menú y página /pages/favoritos */
(function () {
  var KEY = 'bb-favoritos';
  function leer() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function guardar(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  var cuenta = window.bbCuenta || { cliente: true };
  // Sin sesión: aviso para iniciar sesión; el producto queda pendiente y se guarda al volver con la cuenta
  var aviso = document.querySelector('[data-bb-favlogin]'), ultimoFoco;
  function abrirAviso(h) {
    try { if (h) localStorage.setItem(KEY + '-pendiente', h); } catch (e) {}
    if (!aviso) { location.href = irLogin(); return; }
    ultimoFoco = document.activeElement;
    aviso.hidden = false; document.documentElement.classList.add('bb-favlogin-abierto');
    var b = aviso.querySelector('[data-bb-favlogin-ir]'); if (b) b.focus();
  }
  function cerrarAviso() {
    if (!aviso || aviso.hidden) return;
    aviso.hidden = true; document.documentElement.classList.remove('bb-favlogin-abierto');
    try { localStorage.removeItem(KEY + '-pendiente'); } catch (e) {}
    if (ultimoFoco) ultimoFoco.focus();
  }
  function irLogin() {
    var u = cuenta.login || '/account/login';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'return_url=' + encodeURIComponent(location.pathname + location.search);
  }
  document.addEventListener('click', function (ev) {
    var ir = ev.target.closest && ev.target.closest('[data-bb-favlogin-ir]');
    if (ir) { ir.href = irLogin(); return; }
    if (ev.target.closest && ev.target.closest('[data-bb-favlogin-cerrar]')) cerrarAviso();
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') cerrarAviso(); });
  function pintar() {
    var l = cuenta.cliente ? leer() : [];
    document.querySelectorAll('[data-bb-fav]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-bb-fav')) > -1;
      if (b.getAttribute('aria-pressed') === String(on)) return;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = b.getAttribute('aria-label');
      b.setAttribute('aria-label', on ? t.replace(/^Guardar/, 'Quitar').replace(/ en favoritos$/, ' de favoritos') : t.replace(/^Quitar/, 'Guardar').replace(/ de favoritos$/, ' en favoritos'));
    });
    document.querySelectorAll('a[href$="/pages/favoritos"]').forEach(function (a) {
      var c = a.querySelector('.bb-fav-count');
      if (!c) { c = document.createElement('span'); c.className = 'bb-fav-count'; a.appendChild(c); }
      if (c.textContent !== String(l.length)) c.textContent = l.length;
      c.hidden = l.length === 0;
    });
  }
  function vacio() {
    var lista = document.querySelector('[data-bb-fav-list]'); if (!lista) return;
    var e = document.querySelector('[data-bb-fav-empty]'); if (e) e.hidden = lista.children.length > 0;
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-bb-fav]');
    if (!b) return;
    ev.preventDefault();
    if (!cuenta.cliente) { abrirAviso(b.getAttribute('data-bb-fav')); return; }
    var h = b.getAttribute('data-bb-fav'), l = leer(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else { l.unshift(h); b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 260); }
    guardar(l); pintar();
    if (i > -1 && b.closest('[data-bb-fav-list]')) { var card = b.closest('.bb-card'); card.classList.add('is-leaving'); setTimeout(function () { card.remove(); vacio(); }, 260); }
  });
  function cargarPagina() {
    var lista = document.querySelector('[data-bb-fav-list]'); if (!lista) return;
    var l = leer();
    if (!l.length) { vacio(); return; }
    Promise.all(l.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=bb-tarjeta').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var vivos = [];
      htmls.forEach(function (html, k) { if (html.indexOf('bb-card') > -1) { lista.insertAdjacentHTML('beforeend', html); vivos.push(l[k]); } });
      if (vivos.length !== l.length) guardar(vivos);
      pintar(); vacio();
    });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) pintar(); });
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(pintar, 150); }).observe(document.body, { childList: true, subtree: true });
  function init() {
    if (cuenta.cliente) {
      try {
        var p = localStorage.getItem(KEY + '-pendiente');
        if (p) { localStorage.removeItem(KEY + '-pendiente'); var l = leer(); if (l.indexOf(p) < 0) { l.unshift(p); guardar(l); } }
      } catch (e) {}
    }
    pintar(); cargarPagina();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Inicio de sesión: al abrir la ventana de cuenta, muestra siempre Google y el campo de correo
   (pulsa solo "Más formas de iniciar sesión" si Shopify lo esconde). */
(function () {
  function buscar(raiz, n) {
    if (!raiz || n > 6) return null;
    var els = raiz.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.tagName === 'BUTTON' && /m[aá]s formas de iniciar|more sign.?in options/i.test(e.textContent)) return e;
      if (e.shadowRoot) { var x = buscar(e.shadowRoot, n + 1); if (x) return x; }
    }
    return null;
  }
  function expandir(cuenta) {
    var intentos = 0;
    var t = setInterval(function () {
      intentos++;
      var b = buscar(cuenta.shadowRoot, 0);
      if (b) {
        clearInterval(t);
        b.click();
        setTimeout(function () { var a = document.activeElement; if (a && a.blur) a.blur(); if (cuenta.shadowRoot && cuenta.shadowRoot.activeElement) cuenta.shadowRoot.activeElement.blur(); }, 60);
      } else if (intentos > 30) clearInterval(t);
    }, 100);
  }
  function init() {
    document.querySelectorAll('shopify-account').forEach(function (c) {
      if (c.dataset.bbExpand) return;
      c.dataset.bbExpand = '1';
      c.addEventListener('open', function () { expandir(c); });
      c.addEventListener('click', function () { setTimeout(function () { expandir(c); }, 150); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Enlace «Deja tu reseña» (correo de pedido entregado): /products/x#escribir-resena baja a las reseñas y abre el formulario de Judge.me */
(function () {
  if (location.hash !== '#escribir-resena') return;
  var intentos = 0;
  (function buscar() {
    var caja = document.getElementById('judgeme_product_reviews');
    var btn = caja && Array.prototype.find.call(caja.querySelectorAll('button, a'), function (b) { return b.offsetParent && /jm-action-buttons__button|jdgm-write-rev-link/.test(b.className); });
    if (btn) { caja.scrollIntoView({ block: 'start' }); setTimeout(function () { btn.click(); }, 400); return; }
    if (++intentos < 40) setTimeout(buscar, 250);
    else if (caja) caja.scrollIntoView({ block: 'start' });
  })();
})();

/* Rueda de opiniones (Judge.me): 3 tarjetas al frente (las laterales en diagonal) y el resto girando por detrás, de espaldas.
   Judge.me solo marca la tarjeta «active»; aquí se calcula el lugar de cada una. Se puede avanzar con las flechas,
   tocando cualquier tarjeta o arrastrando. Las reseñas largas se recortan y al tocarlas Judge.me las muestra completas. */
(function () {
  var GIRO = 22; // grados de las tarjetas laterales

  // Lugar de una tarjeta a «d» pasos de la del centro (d puede ser decimal mientras se arrastra)
  function lugar(d, paso, sep, radio) {
    var s = d < 0 ? -1 : 1, ad = Math.abs(d);
    function atras(v) {
      var rad = v * paso * Math.PI / 180;
      return { tx: radio * 1.25 * Math.sin(rad), tz: -radio * (1 - Math.cos(rad)) * 0.85 - 40, r: v * paso };
    }
    if (ad <= 1) return { tx: d * sep * 0.97, tz: -ad * 40, r: d * GIRO };
    if (ad < 2) {
      var a = lugar(s, paso, sep, radio), b = atras(2 * s), t = ad - 1;
      return { tx: a.tx + (b.tx - a.tx) * t, tz: a.tz + (b.tz - a.tz) * t, r: a.r + (b.r - a.r) * t };
    }
    return atras(d);
  }

  function preparar(caja) {
    if (caja.dataset.bbTres) return;
    caja.dataset.bbTres = '1';
    var widget = caja.closest('.jdgm-testimonials-carousel');
    widget.classList.add('bb-tres');
    var ultimo = -1, medidas = {};
    // Orden propio: las reseñas de una misma persona quedan intercaladas (Judge.me las trae seguidas).
    // El carrusel lleva su propia tarjeta central («pos»), su cambio automático y sus flechas; el orden interno de Judge.me se ignora.
    var secuencia = [], pos = 0, ultimaAccion = 0;
    function autor(x) { var e = x.querySelector('.jdgm-reviewer-name'); return e ? e.textContent.trim().toLowerCase() : ''; }
    function intercalar(lista) {
      var resto = lista.slice(), out = [];
      while (resto.length) {
        var prev = out.length ? autor(out[out.length - 1]) : null, cuenta = {};
        resto.forEach(function (x) { cuenta[autor(x)] = (cuenta[autor(x)] || 0) + 1; });
        var cands = resto.filter(function (x) { return autor(x) !== prev; });
        if (!cands.length) cands = resto;
        cands.sort(function (a, b) { return cuenta[autor(b)] - cuenta[autor(a)]; });
        out.push(cands[0]); resto.splice(resto.indexOf(cands[0]), 1);
      }
      return out;
    }
    function tarjetas() {
      var dom = Array.prototype.slice.call(caja.querySelectorAll('.jdgm-carousel-item'));
      var cambio = dom.length !== secuencia.length || secuencia.some(function (x) { return !x.isConnected; }) || secuencia.some(function (x) { return !autor(x); });
      if (cambio) { var actual = secuencia[pos]; secuencia = intercalar(dom); pos = Math.max(0, secuencia.indexOf(actual)); }
      return secuencia;
    }
    function activa() { return pos; }

    // Ubica cada tarjeta; «corrimiento» desplaza todo mientras se arrastra (en tarjetas, negativo = hacia la izquierda)
    function ubicar(corrimiento) {
      var items = tarjetas(), n = items.length, i = activa(items);
      if (!n) return;
      var paso = 360 / n, ancho = items[0].offsetWidth, sep = ancho + 18, radio = sep * 1.05;
      medidas = { n: n, sep: sep };
      items.forEach(function (x, k) {
        var d = (k - i + n) % n;
        if (d > n / 2) d -= n;
        if (n < 3 && d !== 0) d = 2;
        var p = lugar(d + (corrimiento || 0), paso, sep, radio);
        var previo = parseFloat(x.dataset.bbRot), r = p.r;
        if (!isNaN(previo)) r += 360 * Math.round((previo - r) / 360); // gira siempre por el camino corto
        if (!corrimiento) x.dataset.bbRot = String(r);
        x.style.setProperty('--bb-tx', Math.round(p.tx) + 'px');
        // +45px: la rueda se adelanta para que las tarjetas inclinadas no queden detrás del plano de la página (si no, no reciben clics)
        x.style.setProperty('--bb-tz', Math.round(p.tz + 45) + 'px');
        x.style.setProperty('--bb-r', r.toFixed(1) + 'deg');
        x.dataset.bbD = String(d);
        x.dataset.bbPos = Math.abs(d) <= 1 ? String(d) : 'atras';
      });
      accesible();
    }
    // Solo la tarjeta central se puede tocar con el teclado/lector (Judge.me marca otra como activa)
    function accesible() {
      tarjetas().forEach(function (x) {
        var central = x.dataset.bbD === '0';
        if (central && x.hasAttribute('inert')) x.removeAttribute('inert');
        if (!central && !x.hasAttribute('inert')) x.setAttribute('inert', '');
        var oculto = central ? 'false' : 'true';
        if (x.getAttribute('aria-hidden') !== oculto) x.setAttribute('aria-hidden', oculto);
      });
    }
    function marcar() {
      var items = tarjetas(), i = activa(items);
      var sinLugar = items.some(function (x) { return x.dataset.bbPos === undefined; });
      if (!items.length || (i === ultimo && !sinLugar)) return;
      ultimo = i;
      ubicar(0);
      fichas();
      recortar();
    }

    // Mini ficha «Compró» con la foto del producto reseñado (fotos en window.bbFotosProd, desde layout/theme.liquid)
    function fichas() {
      var fotos = window.bbFotosProd || {};
      tarjetas().forEach(function (x) {
        if (x.querySelector('.bb-prod')) return;
        var a = x.querySelector('.jdgm-product-name a'); if (!a) return;
        var handle = (a.getAttribute('href') || '').split('/products/')[1];
        handle = handle ? handle.split(/[?#/]/)[0] : '';
        var foto = fotos[handle];
        var f = document.createElement('a');
        f.className = 'bb-prod'; f.href = a.getAttribute('href');
        f.innerHTML = (foto ? '<img alt="" width="64" height="64">' : '') + '<span><small>Compró</small><b></b></span>';
        if (foto) f.querySelector('img').src = foto;
        f.querySelector('b').textContent = a.textContent.trim();
        a.closest('.jdgm-product-name').insertAdjacentElement('afterend', f);
        x.classList.add('bb-con-prod');
      });
    }

    // Reseñas largas: se recortan con «…» y se agrega «Leer completa»
    function recortar() {
      tarjetas().forEach(function (x) {
        var t = x.querySelector('.jdgm-text'); if (!t) return;
        var larga = t.scrollHeight > t.clientHeight + 2;
        var btn = x.querySelector('.bb-leer');
        if (larga && !btn) { btn = document.createElement('button'); btn.type = 'button'; btn.className = 'bb-leer'; btn.textContent = 'Leer completa'; t.insertAdjacentElement('afterend', btn); }
        if (btn) btn.hidden = !larga;
      });
    }

    // Avanza «k» tarjetas en el orden propio (positivo = siguiente). «auto» = cambio automático (no cuenta como acción de la persona)
    function avanzar(k, auto) {
      var n = tarjetas().length;
      if (!auto) ultimaAccion = Date.now();
      if (n && k) pos = ((pos + Math.round(k)) % n + n) % n;
      ultimo = -1; marcar();
    }
    // Flechas de Judge.me: se atienden aquí para seguir el orden propio
    widget.addEventListener('click', function (e) {
      var fl = e.target.closest('.jdgm-arrow'); if (!fl) return;
      e.stopPropagation(); e.preventDefault();
      var flechas = Array.prototype.slice.call(widget.querySelectorAll('.jdgm-arrow'));
      avanzar(flechas.indexOf(fl) === 0 ? -1 : 1);
    }, true);
    // Cambio automático cada 5 s; se pausa 8 s después de que la persona use flechas, toques o arrastre
    setInterval(function () {
      if (document.hidden || arrastrando || Date.now() - ultimaAccion < 8000) return;
      var r = widget.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      avanzar(1, true);
    }, 5000);

    // El navegador no detecta toques sobre tarjetas inclinadas en 3D (el toque cae en el widget):
    // se averigua la tarjeta por la posición del toque, empezando por la del centro y luego las de adelante.
    function tarjetaEn(x, y) {
      var orden = ['0', '-1', '1'], items = tarjetas();
      for (var o = 0; o < orden.length; o++) {
        for (var k = 0; k < items.length; k++) {
          if (items[k].dataset.bbPos !== orden[o]) continue;
          var r = items[k].getBoundingClientRect();
          if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return items[k];
        }
      }
      return null;
    }
    function fueraDeTarjetas(e) { return e.target.closest('.jdgm-arrow, .jdgm-header, .jdgm-arrows--bottom'); }

    // Arrastrar con el mouse o el dedo
    var inicioX = null, dx = 0, arrastrando = false, recienArrastrado = false;
    widget.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.target.closest('a, .bb-leer') || fueraDeTarjetas(e)) return;
      inicioX = e.clientX; dx = 0; arrastrando = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (inicioX === null) return;
      dx = e.clientX - inicioX;
      if (!arrastrando && Math.abs(dx) > 6) { arrastrando = true; widget.classList.add('bb-arrastre'); }
      if (arrastrando && medidas.sep) ubicar(Math.max(-1.6, Math.min(1.6, dx / medidas.sep)));
    });
    window.addEventListener('pointerup', function () {
      if (inicioX === null) return;
      inicioX = null;
      if (!arrastrando) return;
      arrastrando = false; recienArrastrado = true;
      setTimeout(function () { recienArrastrado = false; }, 50);
      widget.classList.remove('bb-arrastre');
      var pasos = medidas.sep ? Math.round(Math.max(-1.6, Math.min(1.6, -dx / medidas.sep))) : 0;
      if (Math.abs(dx) > 40 && !pasos) pasos = dx < 0 ? 1 : -1;
      avanzar(pasos);
    });

    // Tocar (se atiende antes que Judge.me): una tarjeta que no está al centro gira la rueda hasta traerla.
    // En la del centro solo la reseña recortada deja pasar el toque, y Judge.me abre su ventana con la reseña completa.
    widget.addEventListener('click', function (e) {
      if (e.target.closest('a') || fueraDeTarjetas(e)) return;
      var item = e.target.closest('.jdgm-carousel-item') || tarjetaEn(e.clientX, e.clientY); if (!item) return;
      var d = parseFloat(item.dataset.bbD) || 0;
      var leer = d === 0 && !recienArrastrado && item.querySelector('.bb-leer:not([hidden])') && e.target.closest('.bb-leer, .jdgm-text');
      if (leer) return;
      e.stopPropagation(); e.preventDefault();
      if (!recienArrastrado && d !== 0) avanzar(d);
    }, true);

    var espera;
    window.addEventListener('resize', function () { clearTimeout(espera); espera = setTimeout(function () { ultimo = -1; marcar(); }, 150); });
    marcar();
    new MutationObserver(function () { marcar(); accesible(); }).observe(caja, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'inert'] });
  }
  function buscar() { document.querySelectorAll('.jdgm-testimonials-carousel .jdgm-testimonials-container').forEach(preparar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buscar); else buscar();
  var veces = 0, obs = new MutationObserver(function () { buscar(); if (++veces > 300) obs.disconnect(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
